/* eslint-disable */
export default class ErrorsHelper {
  static addError(errors, field, message) {
    if (!errors[field]) {
      errors[field] = [];
    }
    errors[field].push(message);
  }

  /**
   * Alimente l'objet errors en cas de champ invalide
   * @param requiredFields : Liste des champs required
   * @param model : model du formulaire
   * @param errors : object error qui contiendra les eventuelles erreurs
   * @returns {boolean} return false si il y a une erreur
   */
  static checkErrors(requiredFields, model, errors) {
    let valid = true;
    model.id = model.id + 1;
    requiredFields.forEach((field) => {
      if (!model.hasOwnProperty(field) || (model[field].hour == -1 || model[field].mint == -1) || (model.hasOwnProperty(field) && (!model[field] || model[field].length === 0 || model[field] === 0))) {
        model.id ? this.addError(errors, `${field}${(model.id -1)}`, 'Champ obligatoire') :
        this.addError(errors, field, 'Champ obligatoire');
        valid = false;
      }
    });
    return valid;
  }z
}
